import { useQuery } from '@tanstack/react-query'
import { BookingEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetBookings(): {
  bookings: BookingEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
} {
  const {
    data: bookings,
    isLoading,
    isError,
  } = useQuery(['bookings'], async () => {
    return qoursesApi.payment.paymentControllerGetBookingsV1()
  })

  let isEmpty = true

  if (bookings === undefined) {
    return { bookings: [], isLoading, isEmpty, isError }
  }

  if (bookings.length > 0) {
    isEmpty = false
  }

  return { bookings, isLoading, isEmpty, isError }
}

export const GetBookingsQueryKey = () => ['bookings']
